import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "components/library/Button";
import styles from "./ReadOnlyPanel.css";

export default function ReadOnlyPanel(props) {
  if (!props.isVisible) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className={styles.description}>{props.description}</div>
      <Button
        onClick={props.onClick}
        className={classNames(styles.button, "gtm-kick-out")}
        data-cy="startEditingButton"
      >
        {props.button}
      </Button>
    </div>
  );
}

ReadOnlyPanel.propTypes = {
  isVisible: PropTypes.bool,
  button: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
};
